/* assets/product-browser.js */

(function () {
  function getLocale() {
    return String(window.PB_locale || document.documentElement.lang || 'en').toLowerCase();
  }

  function isFrench() {
    return getLocale().indexOf('fr') === 0;
  }

  function t(key, vars = {}) {
    const dict = {
      en: {
        in_stock: 'In stock',
        sold_out: 'Sold out',
        bundle_line: 'Bundle: {{count}} of 3 products',
        add_bundle_error: 'Could not add bundle to cart.',
        empty_selection: 'Select a product'
      },
      fr: {
        in_stock: 'En stock',
        sold_out: 'Rupture de stock',
        bundle_line: 'Bundle : {{count}} sur 3 produits',
        add_bundle_error: "Impossible d'ajouter le bundle au panier.",
        empty_selection: 'Sélectionnez un produit'
      }
    };

    const locale = isFrench() ? 'fr' : 'en';
    let str = (dict[locale] && dict[locale][key]) || dict.en[key] || key;

    Object.keys(vars).forEach((k) => {
      str = str.replace(`{{${k}}}`, vars[k]);
    });

    return str;
  }

  function formatMoney(cents) {
    const format = window.PB_money_format || '${{amount}}';
    const c = Number(cents) || 0;

    const amount = (c / 100).toFixed(2);
    const amountNoDecimals = String(Math.round(c / 100));

    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals.replace('.', ','));
  }

  function setMoney(el, cents, prefix = '') {
    if (!el) return;
    el.innerHTML = prefix + formatMoney(Number(cents) || 0);
  }

  function uid() {
    return Math.random().toString(16).slice(2) + Date.now().toString(16);
  }

  function discountPctForBundle(items) {
    const count = items.length;

    if (count >= 3) return 0.20;

    const hasTop = items.some((it) => it.category === 'tops');
    const hasBottom = items.some((it) => it.category === 'bottoms');
    if (hasTop && hasBottom) return 0.15;

    return 0;
  }

  function init(root) {
    const sectionId = root.dataset.sectionId || 'default';
    const STORAGE_KEY = `pb_bundle_${sectionId}`;

    const tabs = Array.from(root.querySelectorAll('[data-tab]'));
    const thumbs = Array.from(root.querySelectorAll('.ProductBrowser__thumb[data-handle][data-cat]'));
    const bikeFilters = Array.from(root.querySelectorAll('[data-bike-filter-option]'));

    const hero0 = root.querySelector('[data-hero="0"]');
    const hero1 = root.querySelector('[data-hero="1"]');
    const heroPrev = root.querySelector('[data-hero-prev]');
    const heroNext = root.querySelector('[data-hero-next]');

    const viewLink = root.querySelector('[data-view]');
    const titleEl = root.querySelector('[data-title]');
    const priceEl = root.querySelector('[data-price]');
    const variantsWrap = root.querySelector('[data-variants]');
    const stockEl = root.querySelector('[data-stock]');
    const selectBtn = root.querySelector('[data-select]');

    const ratingWrap = root.querySelector('[data-rating]');
    const ratingStars = root.querySelector('[data-rating-stars]');
    const ratingText = root.querySelector('[data-rating-text]');

    const featuresWrap = root.querySelector('[data-features]');
    const featuresList = root.querySelector('[data-features-list]');

    const bundleLine = root.querySelector('[data-bundle-line]');
    const bundleThumbs = root.querySelector('[data-bundle-thumbs]');
    const bundleTotals = root.querySelector('[data-bundle-totals]');
    const bundleSubtotalEl = root.querySelector('[data-bundle-subtotal]');
    const bundleSavePctEl = root.querySelector('[data-bundle-save-pct]');
    const bundleSaveEl = root.querySelector('[data-bundle-save]');
    const bundleTotalEl = root.querySelector('[data-bundle-total]');
    const bundleAddBtn = root.querySelector('[data-bundle-add]');
    const bundleClearBtn = root.querySelector('[data-bundle-clear]');

    let activeCat = 'tops';
    let activeProduct = null;
    let activeVariant = null;

    let bundleId = null;
    let bundleItems = [];

    let activeHeroIndex = 0;
    let hasSecondHero = false;

    function normalize(v) {
      return String(v || '').trim().toLowerCase();
    }

    function getSelectedBikeType() {
      const active = root.querySelector('[data-bike-filter-option].is-active');
      return active ? normalize(active.dataset.bikeType) : '';
    }

    function matchesBike(productBikeType, selectedBikeType) {
      if (!selectedBikeType) return true;

      const values = String(productBikeType || '')
        .split(',')
        .map((v) => normalize(v))
        .filter(Boolean);

      return values.includes(selectedBikeType);
    }

    function getProduct(handle) {
      const node = root.querySelector(`script[data-product="${handle}"]`);
      if (!node) return null;

      try {
        return JSON.parse(node.textContent);
      } catch (e) {
        console.error('Invalid product JSON', e);
        return null;
      }
    }

    function saveBundle() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ bundleId, items: bundleItems }));
      } catch (e) {}
    }

    function loadBundle() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return;

        const data = JSON.parse(raw);

        if (data && data.bundleId && Array.isArray(data.items)) {
          bundleId = data.bundleId;
          bundleItems = data.items;
        }
      } catch (e) {}
    }

    function updateTabCounts() {
      const selectedBike = getSelectedBikeType();
      const counts = { tops: 0, bottoms: 0, accessories: 0 };

      thumbs.forEach((th) => {
        const cat = th.dataset.cat;
        const bike = th.dataset.bikeType || '';

        if (matchesBike(bike, selectedBike)) {
          if (counts[cat] !== undefined) counts[cat]++;
        }
      });

      Object.keys(counts).forEach((cat) => {
        const el = root.querySelector(`[data-tab-count="${cat}"]`);
        if (el) el.textContent = counts[cat];
      });
    }

    function clearProductPanel() {
      activeProduct = null;
      activeVariant = null;
      activeHeroIndex = 0;
      hasSecondHero = false;

      if (viewLink) {
        viewLink.href = '#';
        viewLink.style.display = 'none';
      }

      if (titleEl) titleEl.textContent = t('empty_selection');
      if (priceEl) priceEl.textContent = '';
      if (stockEl) stockEl.textContent = '';

      if (selectBtn) selectBtn.disabled = true;

      if (variantsWrap) {
        variantsWrap.innerHTML = '';
        variantsWrap.style.display = 'none';
      }

      if (featuresWrap) {
        featuresWrap.style.display = 'none';
      }

      if (ratingWrap) {
        ratingWrap.style.display = 'none';
      }

      if (ratingStars) ratingStars.innerHTML = '';
      if (ratingText) ratingText.textContent = '';

      if (hero0) {
        hero0.removeAttribute('src');
        hero0.alt = '';
        hero0.classList.add('is-active');
      }

      if (hero1) {
        hero1.removeAttribute('src');
        hero1.alt = '';
        hero1.style.display = 'none';
        hero1.classList.remove('is-active');
      }
    }

    function applyFilters() {
      const selectedBike = getSelectedBikeType();

      thumbs.forEach((th) => {
        const catMatch = th.dataset.cat === activeCat;
        const bikeMatch = matchesBike(th.dataset.bikeType, selectedBike);

        const show = catMatch && bikeMatch;
        th.style.display = show ? '' : 'none';
        th.classList.remove('is-active');
      });

      updateTabCounts();

      const first = thumbs.find((th) => {
        return th.dataset.cat === activeCat && matchesBike(th.dataset.bikeType, selectedBike);
      });

      if (first) {
        first.click();
      } else {
        clearProductPanel();
      }
    }

    function renderProduct(product) {
      activeProduct = product;

      if (viewLink) {
        viewLink.href = product.url || '#';
        viewLink.style.display = product.url ? '' : 'none';
      }

      if (titleEl) titleEl.textContent = product.title || '';

      const variants = product.variants || [];
      activeVariant = variants.find((v) => v.available) || variants[0] || null;

      if (activeVariant) {
        setMoney(priceEl, activeVariant.price);

        if (stockEl) {
          stockEl.textContent = activeVariant.available ? t('in_stock') : t('sold_out');
        }

        if (selectBtn) {
          selectBtn.disabled = !activeVariant.available;
        }
      } else {
        if (priceEl) priceEl.textContent = '';
        if (stockEl) stockEl.textContent = '';
        if (selectBtn) selectBtn.disabled = true;
      }

      const imgs = product.images || [];
      const imgA = imgs[0] || product.featured_image || '';
      const imgB = imgs[1] || null;

      activeHeroIndex = 0;
      hasSecondHero = !!imgB;

      if (hero0) {
        hero0.src = imgA;
        hero0.alt = product.title || '';
        hero0.classList.add('is-active');
      }

      if (hero1) {
        hero1.src = imgB || imgA;
        hero1.alt = product.title || '';
        hero1.style.display = imgB ? '' : 'none';
        hero1.classList.remove('is-active');
      }

      if (ratingWrap) {
        const val = Number(product.rating_value) || 0;
        const count = Number(product.rating_count) || 0;

        if (val && count) {
          ratingWrap.style.display = '';
          if (ratingText) ratingText.textContent = `${val.toFixed(1)} (${count})`;

          if (ratingStars) {
            const rounded = Math.round(val);
            ratingStars.innerHTML = '★'.repeat(rounded) + '☆'.repeat(Math.max(0, 5 - rounded));
          }
        } else {
          ratingWrap.style.display = 'none';
          if (ratingStars) ratingStars.innerHTML = '';
          if (ratingText) ratingText.textContent = '';
        }
      }

      renderSizeVariants(product);
      renderFeatures(product);
    }

    function renderFeatures(product) {
      if (!featuresWrap || !featuresList) return;

      featuresList.innerHTML = '';

      if (product.features && product.features.length) {
        product.features.forEach((f) => {
          const li = document.createElement('li');
          li.textContent = f;
          featuresList.appendChild(li);
        });

        featuresWrap.style.display = '';
      } else {
        featuresWrap.style.display = 'none';
      }
    }

    function renderSizeVariants(product) {
      if (!variantsWrap) return;

      variantsWrap.innerHTML = '';

      const variants = product.variants || [];

      if (!variants.length) {
        variantsWrap.style.display = 'none';
        return;
      }

      const base = variants.find((v) => v.available) || variants[0];
      activeVariant = base;

      setMoney(priceEl, base.price);

      const sizes = new Map();

      variants.forEach((v) => {
        const sizeKey = v.option2 || v.option1 || v.title || 'Default';
        if (!sizes.has(sizeKey)) sizes.set(sizeKey, v);
      });

      if (sizes.size <= 1) {
        variantsWrap.style.display = 'none';
        return;
      }

      variantsWrap.style.display = '';

      sizes.forEach((variant, size) => {
        const btn = document.createElement('button');
        btn.className = 'ProductBrowser__variantBtn';
        btn.textContent = size;

        if (!variant.available) {
          btn.classList.add('is-disabled');
          btn.disabled = true;
        }

        if (variant.id === base.id) btn.classList.add('is-active');

        btn.addEventListener('click', () => {
          if (!variant.available) return;

          activeVariant = variant;

          variantsWrap
            .querySelectorAll('.ProductBrowser__variantBtn')
            .forEach((b) => b.classList.remove('is-active'));

          btn.classList.add('is-active');

          setMoney(priceEl, variant.price);

          if (stockEl) {
            stockEl.textContent = variant.available ? t('in_stock') : t('sold_out');
          }

          if (selectBtn) {
            selectBtn.disabled = !variant.available;
          }
        });

        variantsWrap.appendChild(btn);
      });
    }

    function addCurrentToBundle() {
      if (!activeProduct || !activeVariant || !activeVariant.available) return;
      if (bundleItems.length >= 3) return;
      if (bundleItems.some((it) => it.variant_id === activeVariant.id)) return;

      if (!bundleId) bundleId = `bundle_${uid()}`;

      bundleItems.push({
        variant_id: activeVariant.id,
        price: activeVariant.price,
        title: activeProduct.title,
        image: activeProduct.featured_image,
        category: activeProduct.category || activeCat
      });

      saveBundle();
      renderBundle();
    }

    function renderBundle() {
      const count = bundleItems.length;

      if (bundleLine) {
        bundleLine.textContent = t('bundle_line', { count: Math.min(count, 3) });
      }

      if (bundleThumbs) bundleThumbs.innerHTML = '';

      bundleItems.forEach((it, idx) => {
        const wrap = document.createElement('div');
        wrap.className = 'BundleSummary__item';

        const img = document.createElement('img');
        img.src = it.image;
        img.alt = it.title || '';
        wrap.appendChild(img);

        const rm = document.createElement('button');
        rm.type = 'button';
        rm.textContent = '×';
        rm.className = 'BundleSummary__remove';

        rm.onclick = () => {
          bundleItems.splice(idx, 1);
          if (!bundleItems.length) bundleId = null;
          saveBundle();
          renderBundle();
        };

        wrap.appendChild(rm);

        if (bundleThumbs) {
          bundleThumbs.appendChild(wrap);
        }
      });

      const subtotal = bundleItems.reduce((s, it) => s + it.price, 0);
      const pct = discountPctForBundle(bundleItems);
      const discount = Math.round(subtotal * pct);
      const total = subtotal - discount;

      if (count) {
        if (bundleTotals) bundleTotals.style.display = '';
        setMoney(bundleSubtotalEl, subtotal);
        if (bundleSavePctEl) bundleSavePctEl.textContent = `${Math.round(pct * 100)}%`;
        setMoney(bundleSaveEl, discount, '- ');
        setMoney(bundleTotalEl, total);
      } else {
        if (bundleTotals) bundleTotals.style.display = 'none';
      }

      const hasTop = bundleItems.some((it) => it.category === 'tops');
      const hasBottom = bundleItems.some((it) => it.category === 'bottoms');

      if (bundleAddBtn) {
        bundleAddBtn.disabled = !(count >= 3 || (hasTop && hasBottom));
      }

      if (bundleClearBtn) {
        bundleClearBtn.style.display = count ? '' : 'none';
      }
    }

    async function addBundleToCart(items, id) {
      const payload = items.map((it, i) => ({
        id: it.variant_id,
        quantity: 1,
        properties: {
          _bundle_id: id,
          _bundle_index: i + 1,
          _bundle_size: items.length
        }
      }));

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: payload })
      });

      if (!res.ok) throw new Error(await res.text());

      return res.json();
    }

    thumbs.forEach((th) => {
      th.addEventListener('click', () => {
        thumbs.forEach((t) => t.classList.remove('is-active'));
        th.classList.add('is-active');

        const product = getProduct(th.dataset.handle);
        if (product) renderProduct(product);
      });
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activeCat = tab.dataset.tab;

        tabs.forEach((t) => {
          const on = t.dataset.tab === activeCat;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        applyFilters();
      });
    });

    bikeFilters.forEach((btn) => {
      btn.addEventListener('click', () => {
        bikeFilters.forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });

        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        applyFilters();
      });
    });

    if (selectBtn) {
      selectBtn.addEventListener('click', addCurrentToBundle);
    }

    if (bundleClearBtn) {
      bundleClearBtn.onclick = () => {
        bundleItems = [];
        bundleId = null;
        saveBundle();
        renderBundle();
      };
    }

    if (bundleAddBtn) {
      bundleAddBtn.onclick = async () => {
        const count = bundleItems.length;
        const hasTop = bundleItems.some((it) => it.category === 'tops');
        const hasBottom = bundleItems.some((it) => it.category === 'bottoms');

        if (!(count >= 3 || (hasTop && hasBottom))) return;

        try {
          await addBundleToCart(bundleItems, bundleId);

          bundleItems = [];
          bundleId = null;

          saveBundle();
          renderBundle();

          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        } catch (e) {
          console.error(e);
          alert(t('add_bundle_error'));
        }
      };
    }

    if (heroPrev) {
      heroPrev.onclick = () => {
        if (!hasSecondHero) return;

        activeHeroIndex = activeHeroIndex === 0 ? 1 : 0;

        if (hero0) hero0.classList.toggle('is-active', activeHeroIndex === 0);
        if (hero1) hero1.classList.toggle('is-active', activeHeroIndex === 1);
      };
    }

    if (heroNext) {
      heroNext.onclick = heroPrev ? heroPrev.onclick : null;
    }

    loadBundle();
    renderBundle();

    const firstTab = tabs.find((t) => t.dataset.tab === activeCat) || tabs[0];
    if (firstTab) firstTab.click();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.ProductBrowser').forEach(init);
  });
})();